export default __webpack_public_path__ + "static/media/img-o-n-video-building-wealth.2a6939c6.jpg";